import { Link, useLocation } from 'react-router-dom';
import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';
import { ActsLogo } from '@/components/ui/ActsLogo';
import { useMainNavItems } from '@/components/rides/BottomTabBar';
import { AccountMenu } from './AccountMenu';
import { ThemeMenu } from './ThemeMenu';

/**
 * Header band. Phones: Acts Church wordmark + "Carpool" on the left (one line at 360 px), and on
 * the right the theme button (signed out) or the avatar menu (signed in, which holds Appearance).
 * Desktop (≥ 769 px): the same band at full width with text navigation.
 */
export function AppHeader() {
  const location = useLocation();
  const { isAuthenticated } = useEnrichedAuth();
  const nav = useMainNavItems();
  const path = location.pathname;
  const onAuthPage = path.startsWith('/auth/');
  const showSignIn = !isAuthenticated && !onAuthPage && path !== '/';

  return (
    <header className="rides-header">
      <div className="rides-header-inner">
        <Link to={isAuthenticated ? '/home' : '/'} className="rides-lockup" aria-label="Acts Church Carpool, home">
          <ActsLogo height={22} alt="" />
          <span className="sep" aria-hidden="true" />
          <span className="name" aria-hidden="true">Carpool</span>
        </Link>
        {isAuthenticated && nav.length > 0 && (
          <nav className="rides-desknav" aria-label="Main">
            {nav.map((item) => {
              const on = item.active(path);
              return (
                <Link key={item.key} to={item.to} aria-current={on ? 'page' : undefined}>
                  {item.label}
                  {item.dot && <><span className="dot" aria-hidden="true" /><span className="sr-only">(ride today)</span></>}
                </Link>
              );
            })}
          </nav>
        )}
        <span className="grow" />
        {isAuthenticated ? (
          <AccountMenu />
        ) : (
          <>
            {showSignIn && (
              <Link className="rides-headlink" to={`/auth/login?redirect=${encodeURIComponent(path + location.search)}`}>Sign in</Link>
            )}
            <ThemeMenu />
          </>
        )}
      </div>
    </header>
  );
}
